<div class="row">
    <div class="col-12">

        <form [formGroup]="quizForm">
            <aw-wizard #wizard class="arc-wizard" navBarLocation="left">

                <aw-wizard-step stepTitle="DOMANDA">
                    <div class="row">
                        <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="domanda">DOMANDA*</label>
                                    <input formControlName="domanda" type="text" class="form-control" id="domanda" aria-describedby="domanda" placeholder="">
                                    <small id="domandaHelp" class="form-text text-muted">Scrivi una domanda</small>
                                </div>
                                <div class="form-group">
                                    <label for="sottotitolo">SOTTOTITOLO</label>
                                    <textarea  formControlName="sottotitolo" class="form-control" id="sottotitolo" aria-describedby="sottotitoloHelp"></textarea>
                                    <small id="sottotitoloHelp" class="form-text text-muted">Scrivi un sottotitolo o un'indicazione aggiuntiva</small>
                                </div>
                                <div class="form-group">
                                    <label for="hasImage">IMMAGINE DOMANDA</label>
                                    <div class="switch m-r-10">
                                        <input type="checkbox" id="hasImage" formControlName="hasImage" aria-describedby="hasImageHelp">
                                        <label for="hasImage" class="cr"></label>
                                    </div>
                                    <small id="hasImageHelp" class="form-text text-muted">La domanda prevede un'immagine?</small>
                                </div>
                                <div class="form-group" *ngIf="f.hasImage.value">
                                    <label>FEATURED IMAGE</label>
                                    <app-media-manager [filePath]="interaction.image" (onFileSelect)="setImageUrl($event, 'featuredImage')"></app-media-manager>
                                </div>
                                <div class="form-group">
                                    <label for="info">INFO</label>
                                    <app-tinymce formControlName="info" id="info" aria-describedby="infoHelp"></app-tinymce>
                                    <small id="infoHelp" class="form-text text-muted">Inserisci le info della tua Interazione</small>
                                </div>
                                <h6>Coordinate:</h6>
                                <div class="form-group">
                                    <label for="lat">LATITUDINE</label>
                                    <input formControlName="lat" type="text" class="form-control" id="lat" aria-describedby="latHelp" placeholder="41.89884227456026">
                                    <small id="latHelp" class="form-text text-muted">Inserisci la latitudine</small>
                                </div>
                                <div class="form-group">
                                    <label for="lat">LONGITUDINE</label>
                                    <input formControlName="lng" type="text" class="form-control" id="lng" aria-describedby="lngHelp" placeholder="12.52539241745996">
                                    <small id="lngHelp" class="form-text text-muted">Longitudine</small>
                                </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateDomanda()" (click)="setDomanda()">Avanti</button>
                        </div>
                    </div>
                </aw-wizard-step>

                <aw-wizard-step stepTitle="RISPOSTE">

                    <div class="col-12" *ngIf="!interaction.interactionData">
                        <label for="domanda" class="mt-0">RISPOSTE*</label>
                        <small class="d-block">Minimo 2 risposte.</small>
                        <a href="javascript:;" class="d-block mt-3" (click)="interaction.interactionData = {risposte: [{}]}">Aggiungi la prima risposta</a>
                    </div>

                    <div class="col-12 mb-3" *ngIf="interaction.interactionData">
                        <!-- TIPOLOGIA RISPOSTE -->
                        <small id="risposteTypeHelp" class="form-text text-muted">Che tipo di risposte ha il tuo quiz?</small>
                        <div class="switch-field  mt-3">
                            <input type="radio" id="text" name="risposteType" value="text" (click)="interaction.interactionData.risposteType = 'text';" [checked]="interaction.interactionData.risposteType === 'text'"/>
                            <label for="text">Solo testo</label>
                            <input type="radio" id="text-image" name="risposteType" value="text-image" (click)="interaction.interactionData.risposteType = 'text-image'" [checked]="interaction.interactionData.risposteType === 'text-image'"/>
                            <label for="text-image">Testo e immagine</label>
                            <input type="radio" id="image" name="risposteType" value="image" (click)="interaction.interactionData.risposteType = 'image'" [checked]="interaction.interactionData.risposteType === 'image'"/>
                            <label for="image">Solo immagine</label>
                        </div>
                    </div>
                    <div class="col-12 mt-3" *ngIf="interaction.interactionData">
                        <div class="row" *ngFor="let risposta of interaction.interactionData.risposte; let i = index">
                            <div class="col-1 text-center text-uppercase text-primary">{{alphaIndex[i]}}</div>
                            <div class="col-10">
                                <input *ngIf="interaction.interactionData.risposteType !== 'image'" class="w-100 mb-2" type="text" [placeholder]="'Risposta ' + alphaIndex[i]" (keyup)="setRisposta(i, $event)" [value]="risposta.label ? risposta.label : ''">
                                <app-media-manager *ngIf="interaction.interactionData.risposteType !== 'text'" [filePath]="risposta.image" (onFileSelect)="setImmagineRisposta(i, $event)"></app-media-manager>
                            </div>
                            <div class="col-1" (click)="deleteRisposta(risposta)">
                                <i class="fas fa-trash"></i>
                            </div>
                        </div>
                        <a href="javascript:;" class="d-block mt-3 btn btn-default btn-sm" (click)="interaction.interactionData.risposte.push({})"><i class="fas fa-plus mr-1"></i>Aggiungi un'altra risposta</a>
                    </div>
                    <div class="col-sm-12 mt-3 d-flex justify-content-end" *ngIf="interaction.interactionData">
                        <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateRisposte()">Avanti</button>
                    </div>
                </aw-wizard-step>

                <aw-wizard-step stepTitle="RISULTATO">
                    <div class="row">
                        <div class="col-12"  *ngIf="interaction.interactionData">
                            <label for="hasImage">RISPOSTA ESATTA</label>
                            <small class="form-text text-muted">Seleziona la risposta esatta!</small>
                            <ul class="list-group mt-3" >
                                <li class="list-group-item"
                                    *ngFor="let risposta of interaction.interactionData.risposte; let i = index;"
                                    (click)="setRisultatoQuiz(i)"
                                    [class.bg-primary]="risposta.value"
                                    [class.text-white]="risposta.value">
                                    <span *ngIf="interaction.interactionData.risposteType !== 'image'">{{risposta.label}}</span>
                                    <img [src]="environment.imageCDN + environment.imageFolder + '/' + risposta.image" *ngIf="interaction.interactionData.risposteType === 'image'">
                                </li>
                            </ul>
                            <div class="col-sm-12 mt-3 d-flex justify-content-end mt-3">
                                <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateRisultato()" (click)="onAddInteraction()">Avanti</button>
                            </div>
                        </div>
                    </div>
                </aw-wizard-step>
            
            </aw-wizard>
        </form>
    </div>
</div>

<!-- {{interaction | json}} -->